export enum SignInStep {
  SignIn = 'SignIn',
  ForgotPassword = 'ForgotPassword',
  EnterConfirmationCode = 'EnterConfirmationCode',
  CreateAccount = 'CreateAccount',
  SentResetPasswordLink = 'SentResetPasswordLink',
  NotFoundContact = 'NotFoundContact',
}
